import React, {useEffect, useState} from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Swiper, SwiperSlide } from 'swiper/react'
import DetailsVideo from '../../video/details-video'

export default props => {
    useStyles(classes)
    const { videos, positionChange, position } = props

    const [swiper, setSwiper] = useState(null)
    const [muted, setMuted] = useState(true)

    const endedHandle = () => {
        if (swiper) {
            if(position + 1 <= videos.length - 1){
                swiper.slideNext()
            }else{
                swiper.slideTo(0, 0)
            }
            
        }else{
            console.log('ended')
        }
    }

    const slideChangeHandle = (sw) => {
        positionChange?.(sw.activeIndex)
    }

    return <Swiper initialSlide={position}  className={`${classes.VideoSwiper} ${position}`} direction='vertical' onSwiper={setSwiper} slidesPerView={1} onSlideChange={slideChangeHandle}>
        {
            videos.map((video, index) => {
                return <SwiperSlide key={index} className={classes.VideoSwiperSlide}>
                    <DetailsVideo isDetails setMuted={setMuted} muted={muted} video={video} endedHandle={endedHandle} shouldPlay={position === index} />
                </SwiperSlide>
            })
        }
    </Swiper>
}